import { TimesConstants } from '../store/times.constants'

export const timesSchemas = [
  {
    inputKey: TimesConstants.SET_ACKNOWLEDGED_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ACKNOWLEDGED_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_ACKNOWLEDGED_DATE'],
    errorMessage: {
      properties: {
        SET_ACKNOWLEDGED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ONSET_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ONSET_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_ONSET_DATE'],
    errorMessage: {
      properties: {
        SET_ONSET_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_RECEIVED_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RECEIVED_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_RECEIVED_DATE'],
    errorMessage: {
      properties: {
        SET_RECEIVED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DISPATCH_NOTIFIED_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_NOTIFIED_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_NOTIFIED_DATE'],
    errorMessage: {
      properties: {
        SET_DISPATCH_NOTIFIED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_STANDBY_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STANDBY_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_STANDBY_DATE'],
    errorMessage: {
      properties: {
        SET_STANDBY_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  // {
  //   inputKey: TimesConstants.SET_DISPATCHED_DATE,
  //   isNumber: false,
  //   type: 'object',
  //   properties: {
  //     SET_DISPATCHED_DATE: {
  //       type: 'string',
  //       format: 'zoll-now-date',
  //     },
  //   },
  //   additionalProperties: false,
  //   required: ['SET_DISPATCHED_DATE'],
  //   errorMessage: {
  //     properties: {
  //       SET_DISPATCHED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
  //     },
  //   },
  // },
  {
    inputKey: TimesConstants.SET_EN_ROUTE_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_EN_ROUTE_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_EN_ROUTE_DATE'],
    errorMessage: {
      properties: {
        SET_EN_ROUTE_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_STAGING_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STAGING_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_STAGING_DATE'],
    errorMessage: {
      properties: {
        SET_STAGING_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ON_SCENE_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ON_SCENE_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_ON_SCENE_DATE'],
    errorMessage: {
      properties: {
        SET_ON_SCENE_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AT_PATIENT_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AT_PATIENT_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_AT_PATIENT_DATE'],
    errorMessage: {
      properties: {
        SET_AT_PATIENT_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_TRANSFER_CARE_EMS_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSFER_CARE_EMS_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSFER_CARE_EMS_DATE'],
    errorMessage: {
      properties: {
        SET_TRANSFER_CARE_EMS_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_LEAVE_REFERRING_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LEAVE_REFERRING_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_LEAVE_REFERRING_DATE'],
    errorMessage: {
      properties: {
        SET_LEAVE_REFERRING_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ARRIVE_RECEIVING_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ARRIVE_RECEIVING_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_ARRIVE_RECEIVING_DATE'],
    errorMessage: {
      properties: {
        SET_ARRIVE_RECEIVING_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_TRANSFER_CARE_DESTINATION_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSFER_CARE_DESTINATION_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSFER_CARE_DESTINATION_DATE'],
    errorMessage: {
      properties: {
        SET_TRANSFER_CARE_DESTINATION_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AVAILABLE_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AVAILABLE_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_AVAILABLE_DATE'],
    errorMessage: {
      properties: {
        SET_AVAILABLE_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_CALL_COMPLETED_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CALL_COMPLETED_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_CALL_COMPLETED_DATE'],
    errorMessage: {
      properties: {
        SET_CALL_COMPLETED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_IN_QUARTERS_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_IN_QUARTERS_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_IN_QUARTERS_DATE'],
    errorMessage: {
      properties: {
        SET_IN_QUARTERS_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_CANCELLED_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CANCELLED_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_CANCELLED_DATE'],
    errorMessage: {
      properties: {
        SET_CANCELLED_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ACKNOWLEDGED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ACKNOWLEDGED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_ACKNOWLEDGED_TIME'],
    errorMessage: {
      properties: {
        SET_ACKNOWLEDGED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ONSET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ONSET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_ONSET_TIME'],
    errorMessage: {
      properties: {
        SET_ONSET_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_RECEIVED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RECEIVED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_RECEIVED_TIME'],
    errorMessage: {
      properties: {
        SET_RECEIVED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DISPATCH_NOTIFIED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_NOTIFIED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_NOTIFIED_TIME'],
    errorMessage: {
      properties: {
        SET_DISPATCH_NOTIFIED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_STANDBY_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STANDBY_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_STANDBY_TIME'],
    errorMessage: {
      properties: {
        SET_STANDBY_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  // {
  //   inputKey: TimesConstants.SET_DISPATCHED_TIME,
  //   isNumber: false,
  //   type: 'object',
  //   properties: {
  //     SET_DISPATCHED_TIME: {
  //       type: 'string',
  //       pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
  //     },
  //   },
  //   additionalProperties: false,
  //   required: ['SET_DISPATCHED_TIME'],
  //   errorMessage: {
  //     properties: {
  //       SET_DISPATCHED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
  //     },
  //   },
  // },
  {
    inputKey: TimesConstants.SET_EN_ROUTE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_EN_ROUTE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_EN_ROUTE_TIME'],
    errorMessage: {
      properties: {
        SET_EN_ROUTE_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_STAGING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STAGING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_STAGING_TIME'],
    errorMessage: {
      properties: {
        SET_STAGING_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ON_SCENE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ON_SCENE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_ON_SCENE_TIME'],
    errorMessage: {
      properties: {
        SET_ON_SCENE_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AT_PATIENT_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AT_PATIENT_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_AT_PATIENT_TIME'],
    errorMessage: {
      properties: {
        SET_AT_PATIENT_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_TRANSFER_CARE_EMS_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSFER_CARE_EMS_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSFER_CARE_EMS_TIME'],
    errorMessage: {
      properties: {
        SET_TRANSFER_CARE_EMS_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_LEAVE_REFERRING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LEAVE_REFERRING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_LEAVE_REFERRING_TIME'],
    errorMessage: {
      properties: {
        SET_LEAVE_REFERRING_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ARRIVE_RECEIVING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ARRIVE_RECEIVING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_ARRIVE_RECEIVING_TIME'],
    errorMessage: {
      properties: {
        SET_ARRIVE_RECEIVING_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_TRANSFER_CARE_DESTINATION_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSFER_CARE_DESTINATION_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSFER_CARE_DESTINATION_TIME'],
    errorMessage: {
      properties: {
        SET_TRANSFER_CARE_DESTINATION_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AVAILABLE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AVAILABLE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_AVAILABLE_TIME'],
    errorMessage: {
      properties: {
        SET_AVAILABLE_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_CALL_COMPLETED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CALL_COMPLETED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_CALL_COMPLETED_TIME'],
    errorMessage: {
      properties: {
        SET_CALL_COMPLETED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_IN_QUARTERS_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_IN_QUARTERS_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_IN_QUARTERS_TIME'],
    errorMessage: {
      properties: {
        SET_IN_QUARTERS_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_CANCELLED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CANCELLED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_CANCELLED_TIME'],
    errorMessage: {
      properties: {
        SET_CANCELLED_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_FIRST_RESPONDER_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRST_RESPONDER_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRST_RESPONDER_DATE'],
    errorMessage: {
      properties: {
        SET_FIRST_RESPONDER_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_FIRST_RESPONDER_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRST_RESPONDER_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRST_RESPONDER_TIME'],
    errorMessage: {
      properties: {
        SET_FIRST_RESPONDER_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_LEAVE_PATIENT_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LEAVE_PATIENT_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_LEAVE_PATIENT_TIME'],
    errorMessage: {
      properties: {
        SET_LEAVE_PATIENT_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_LEAVE_PATIENT_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LEAVE_PATIENT_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_LEAVE_PATIENT_DATE'],
    errorMessage: {
      properties: {
        SET_LEAVE_PATIENT_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DESCENT_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DESCENT_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_DESCENT_TIME'],
    errorMessage: {
      properties: {
        SET_DESCENT_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DESCENT_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DESCENT_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_DESCENT_DATE'],
    errorMessage: {
      properties: {
        SET_DESCENT_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AT_LANDING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AT_LANDING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_AT_LANDING_TIME'],
    errorMessage: {
      properties: {
        SET_AT_LANDING_TIME: 'Must be in the format: HH:MM and between 00:00 and 23:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AT_LANDING_DATE,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AT_LANDING_DATE: {
        type: 'string',
        format: 'zoll-now-date',
      },
    },
    additionalProperties: false,
    required: ['SET_AT_LANDING_DATE'],
    errorMessage: {
      properties: {
        SET_AT_LANDING_DATE: 'Must be in the format: MM/DD/YY and between 01/01/1950 and 01/01/2050',
      },
    },
  },
]

export const timesSecondsSchemas = [
  {
    inputKey: TimesConstants.SET_ACKNOWLEDGED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ACKNOWLEDGED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_ACKNOWLEDGED_TIME'],
    errorMessage: {
      properties: {
        SET_ACKNOWLEDGED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ONSET_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ONSET_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_ONSET_TIME'],
    errorMessage: {
      properties: {
        SET_ONSET_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_RECEIVED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_RECEIVED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_RECEIVED_TIME'],
    errorMessage: {
      properties: {
        SET_RECEIVED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DISPATCH_NOTIFIED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCH_NOTIFIED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCH_NOTIFIED_TIME'],
    errorMessage: {
      properties: {
        SET_DISPATCH_NOTIFIED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_STANDBY_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STANDBY_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_STANDBY_TIME'],
    errorMessage: {
      properties: {
        SET_STANDBY_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DISPATCHED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DISPATCHED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9](?::[0-5][0-9])?$',
      },
    },
    additionalProperties: false,
    required: ['SET_DISPATCHED_TIME'],
    errorMessage: {
      properties: {
        SET_DISPATCHED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_EN_ROUTE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_EN_ROUTE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_EN_ROUTE_TIME'],
    errorMessage: {
      properties: {
        SET_EN_ROUTE_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_STAGING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_STAGING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_STAGING_TIME'],
    errorMessage: {
      properties: {
        SET_STAGING_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ON_SCENE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ON_SCENE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_ON_SCENE_TIME'],
    errorMessage: {
      properties: {
        SET_ON_SCENE_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AT_PATIENT_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AT_PATIENT_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_AT_PATIENT_TIME'],
    errorMessage: {
      properties: {
        SET_AT_PATIENT_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_TRANSFER_CARE_EMS_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSFER_CARE_EMS_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSFER_CARE_EMS_TIME'],
    errorMessage: {
      properties: {
        SET_TRANSFER_CARE_EMS_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_LEAVE_REFERRING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LEAVE_REFERRING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_LEAVE_REFERRING_TIME'],
    errorMessage: {
      properties: {
        SET_LEAVE_REFERRING_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_ARRIVE_RECEIVING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_ARRIVE_RECEIVING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_ARRIVE_RECEIVING_TIME'],
    errorMessage: {
      properties: {
        SET_ARRIVE_RECEIVING_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_TRANSFER_CARE_DESTINATION_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_TRANSFER_CARE_DESTINATION_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_TRANSFER_CARE_DESTINATION_TIME'],
    errorMessage: {
      properties: {
        SET_TRANSFER_CARE_DESTINATION_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AVAILABLE_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AVAILABLE_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_AVAILABLE_TIME'],
    errorMessage: {
      properties: {
        SET_AVAILABLE_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_CALL_COMPLETED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CALL_COMPLETED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_CALL_COMPLETED_TIME'],
    errorMessage: {
      properties: {
        SET_CALL_COMPLETED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_IN_QUARTERS_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_IN_QUARTERS_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_IN_QUARTERS_TIME'],
    errorMessage: {
      properties: {
        SET_IN_QUARTERS_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_CANCELLED_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_CANCELLED_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_CANCELLED_TIME'],
    errorMessage: {
      properties: {
        SET_CANCELLED_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_FIRST_RESPONDER_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_FIRST_RESPONDER_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_FIRST_RESPONDER_TIME'],
    errorMessage: {
      properties: {
        SET_FIRST_RESPONDER_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_LEAVE_PATIENT_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_LEAVE_PATIENT_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_LEAVE_PATIENT_TIME'],
    errorMessage: {
      properties: {
        SET_LEAVE_PATIENT_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_DESCENT_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_DESCENT_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_DESCENT_TIME'],
    errorMessage: {
      properties: {
        SET_DESCENT_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
  {
    inputKey: TimesConstants.SET_AT_LANDING_TIME,
    isNumber: false,
    type: 'object',
    properties: {
      SET_AT_LANDING_TIME: {
        type: 'string',
        pattern: '^([0-1]?[0-9]|2[0-3]):[0-5][0-9]:[0-5][0-9]$',
      },
    },
    additionalProperties: false,
    required: ['SET_AT_LANDING_TIME'],
    errorMessage: {
      properties: {
        SET_AT_LANDING_TIME: 'Must be in the format: HH:MM:SS and between 00:00:00 and 23:59:59',
      },
    },
  },
]
